<template>
  <div id="regist-input">
    <dd-header
      :isMenuView='false'
    />
    <div class="container">
      <section>
        <div class="title">
          <h2>パスワードのリセット</h2>
        </div>
        <div class="input_list">
          <div v-if="errorMessage.text"><label class="error_text">{{ errorMessage.text }}</label></div>
          <div v-if="errors.email"><label class="error_text">{{errors.email}}</label></div>
          <ul>
            <li class="list_key">
              <label class=" text_left">ご登録メールアドレス</label>
            </li>
            <li class="input_mail_field">
              <input type="text" v-model.trim="mailAddress" placeholder="メールアドレスを入力してください。"/>
              <div class="detail_btn btn_pos_left" @click="sendMail()">送信</div>
            </li>
          </ul>
          <p>
            ※受信制限をされている方は、「<span class="pickup">@domans.co.jp</span>」からのメールを受信許可に設定してください<br>
            ※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。
          </p>
        </div>
        <!-- <div class="detail_btn2 btn_pos_center" @click="toLogin">戻る 〉〉</div> -->
      </section>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Check from '../../utils/Check'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// Module
import Header from '../components/common/DcHeader'

export default {
  components: {
    'dd-header': Header,
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      mailAddress: '',
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' }
    }
  },
  methods: {
    toLogin: function () {
      this.$router.push('/mmstyle/login')
    },
    sendMail: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)

      this.errorMessage = {}
      this.errors = {}
      this.validatedReqire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)

      let payload = {
        mailAddress: this.mailAddress
      }
      axios.post(DC_URL.USER + '/reset/send-mail', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.$set(this.errorMessage, 'text', response.data.errorMessage)
          } else {
            this.$router.push('/mmstyle/user/reset/confirm')
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
        .finally(() => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        })
    },
    validatedReqire: function () {
      if (!Check.isMail(this.mailAddress)) {
        this.$set(this.errors, 'email', 'メールアドレスの形式ではありません。')
      }
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.PASSWORD_DATA)
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcPasswordResetInput.vue